import React from 'react';
import BrandImage from '../assets/logo.png'
import StampImage from '../assets/stamp.png'
import SignatureImage from '../assets/signature.png'
import BrandNameImage from '../assets/brand-name.png'
import html2pdf from 'html2pdf.js';
import { Button } from 'antd';
import moment from 'moment';
import { CopyOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const downloadPdf = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
        const options = {
            filename: 'download.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 12 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
        };
        html2pdf()
            .from(element)
            .set(options)
            .save();
    } else {
        console.error(`Element with ID ${elementId} not found`);
    }
};

const certificationTypes = {
    ACHIEVEMENT: 'ACHIEVEMENT',
    COMPELETION: 'COMPELETION',
}
const getCertificationType = (type) => {
    switch (type) {
        case certificationTypes.ACHIEVEMENT: return 'Achievement'
        case certificationTypes.COMPELETION: return 'Completion'
        default: return 'Participation'
    }
}
const Certificate = ({ data, showCopyButton = false }) => {
    const navigate = useNavigate();
    console.log(data)
    const description = `For successfully completing the
    ${Math.ceil(data.hrs)}-${Math.ceil(data.hrs) === 1 ? "Month" : "Months"} course in ${data.courseParentName} by Pronttera. 
     This program covered ${formatArray(data.tags?.slice?.(0, 6))}, with hands-on training and real-world projects under expert guidance.`
    // console.log({ description })
    const handleCopy = () => {
        const { hostname, port } = window.location;
        const domainWithPort = port ? `${hostname}:${port}` : hostname;

        const urlToCopy = `${domainWithPort}/certificate/${data.id}`;

        navigator.clipboard.writeText(urlToCopy)
            .then(() => {
                console.log("Copied to clipboard!");
            })
            .catch(err => {
                console.error("Failed to copy: ", err);
            });
    };

    return (
        <div className="flex flex-col gap-6 py-6">
            {showCopyButton && <div className="p-4 flex justify-center">
                <Button
                    className='mx-auto'
                    onClick={() => handleCopy()}
                    icon={<CopyOutlined />}
                >Copy Certificate URL</Button>
            </div>}

            <div id='certificate' className="relative flex flex-col overflow-hidden relative w-[800px] min-h-[600px] aspect-[1.414/1]  mx-auto py-12 px-8  shadow-lg relative font-sans text-slate-800 border-b border-b-blue-900 pb-4 border-b-[16px]">
                <div className="absolute w-full h-full left-0 top-0 bg-transparent z-10"></div>
                <div className="graphic absolute right-[-23%] top-[-20%] w-96 h-96 rounded-[10%] bg-blue-950 rotate-45 flex justify-start items-end">
                    <img src={BrandNameImage} className='h-14 rotate-[-45deg] relative bottom-16 mb-6 left-6' alt="" />
                </div>
                <div className="header mb-3">
                    <div className="font-bold text-7xl mb-4">Certificate</div>
                    <div className="font-bold text-2xl">Of {getCertificationType(data.type)}</div>
                </div>
                <div className="hero flex-1">
                    <p className='mb-6 text-gray-600 font-semibold' >This certificate is proudly presented to</p>
                    <div className="mb-8">
                        <h1 className='text-5xl mb-3 font-bold font-serif' >{data.recipientName}</h1>
                        {/* <p className='' ></p> */}
                        <p className='font-semibold max-w-[80%]' >{description}</p>
                    </div>
                    <div className="mb-4">
                        <p>Date: {data.issuedAt}</p>
                        <p className='absolute bottom-0 right-4 text-slate-300' >Certificate ID: {data.id}</p>
                    </div>
                </div>

                <div className="border-t border-t-yellow-500 h-1 w-[75%] "></div>
                <div className="footer flex justify-between items-center gap-8 pt-4 ">
                    <div className="flex flex-col gap-0">
                        <img src={SignatureImage} alt="" className='w-[8rem] relative bottom-3 aspect-video object-contain' />
                        <p className='font-medium text-lg mt-[-1rem]' >Adeeb Shah</p>
                        <p className='' >Authorised Signatory</p>
                    </div>
                    <img src={StampImage} alt="" className='h-full w-[9rem] aspect-square object-contain relative bottom-5' />
                </div>
            </div>
        </div>

    );
};

export default Certificate;


function formatArray(arr) {
    if (arr.length === 0) return "";
    if (arr.length === 1) return arr[0];
    return arr.slice(0, -1).join(", ") + ", and " + arr[arr.length - 1];
}